module.exports = __webpack_public_path__ + "img/what-are-coronaviruses-carousel-2-image.9d56edf8.png";